import React from 'react'
import CompareTemplate from 'src/components/template/compare'
import { xfinityData } from 'src/components/template/compare/components/data/xfinityData'

export default (props) => <CompareTemplate location={props.location} data={xfinityData} />
